<template>
<svg xmlns="http://www.w3.org/2000/svg" style="background:#000" viewBox="0 0 24 24"><path fill="#fff" d="M16.6 5.82s.51.5 0 0A4.3 4.3 0 0 1 15.54 3h-3.09v12.4a2.6 2.6 0 0 1-2.59 2.5 2.6 2.6 0 1 1 .77-5.08V9.66A5.7 5.7 0 1 0 9.85 21a5.7 5.7 0 0 0 5.69-5.7V9.01a7.4 7.4 0 0 0 4.3 1.38V7.3s-1.88.09-3.24-1.48"/></svg>
</template>
